import React from "react";
import PropTypes from "prop-types";
import { SC_SaveOptions, SC_onRadioChange } from "../NonComponents/SCUtil";
import { SC_onCheckboxChange } from "../NonComponents/SCDataUtil";

class SCDrawer extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        config: PropTypes.object,
        configExtra: PropTypes.object,
        onConfigChange: PropTypes.func,
        selectedCountryCode: PropTypes.number,
        countryObjList: PropTypes.any,
        displayOL: PropTypes.arrayOf(PropTypes.object),
        indInfo: PropTypes.object,
        catInfo: PropTypes.object,
        siteInfo: PropTypes.object,
        mstIDsObj: PropTypes.object,
        onDrawerChange: PropTypes.func,
        onClose: PropTypes.func,
    };

    static defaultProps = {
        config: {},
        configExtra: {},
        onConfigChange: () => console.log("onConfigChange"),
        selectedCountryCode: 0,
        countryObjList: [],
        displayOL: [],
        indInfo: {},
        catInfo: {},
        siteInfo: {},
        mstIDsObj: null,
        onDrawerChange: () => console.log("onDrawerChange"),
        onClose: () => console.log("onClose"),
    };

    constructor(props) {
        super(props);

        /* Clone App.js's config and work off of the clone in this unit. Do not send config back up to
           App.js until the user hits Close/Save. */
        this.state = {
            configDrawer: JSON.parse(JSON.stringify(this.props.config)),
            configExtraDrawer: JSON.parse(JSON.stringify(this.props.configExtra)),
        };
    }

    componentDidMount() {
        // Child passes its method to the parent
        if (this.props.shareMethods !== null) {
            this.props.shareMethods(this.onSaveBtnClick.bind(this));
        }
    }

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onCheckboxChange = (checked, event, name, caption, info) => {
        SC_onCheckboxChange(
            checked,
            event,
            name,
            caption,
            info,
            this.state.configDrawer,
            this.state.configExtraDrawer,
            this.props.siteInfo,
            this.props.countryObjList,
            this.props.selectedCountryCode,
            (newConfigDrawer) => {
                this.setState({
                    configDrawer: newConfigDrawer,
                });
            }
        );
    };

    onRadioChange = (value, info) => {
        SC_onRadioChange(
            value,
            info,
            this.state.configDrawer,
            this.state.configExtraDrawer,
            (newConfigDrawer, newConfigExtraDrawer) => {
                this.setState({
                    configDrawer: newConfigDrawer,
                    configExtraDrawer: newConfigExtraDrawer,
                });
            }
        );
    };

    onSaveBtnClick = (successFn) => {
        SC_SaveOptions(
            this.state.configDrawer,
            this.state.configExtraDrawer,
            (newConfigDrawer, newConfigExtraDrawer) => {
                this.props.onConfigChange(newConfigDrawer, newConfigExtraDrawer);
                successFn();
            }
        );
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        return null;
    }
}

export default SCDrawer;
